module.exports = __webpack_public_path__ + "static/tabs-switch-dont-84ac2a99b7d471fd22e34a3cda6edc57.png";